export default __webpack_public_path__ + "static/media/bird.4920a2c5.ogg";